import React from 'react';
import PropTypes from 'prop-types';
import Slide from '@material-ui/core/Slide';

export const SLIDE_DIRECTION = {
  DOWN: 'down',
  LEFT: 'left',
  RIGHT: 'right',
  UP: 'up'
};

const RepliconSlide = ({
  in: openCloseState,
  children,
  direction = SLIDE_DIRECTION.UP
}) => (
  <Slide
    in={openCloseState}
    // eslint-disable-next-line react/no-children-prop
    children={children}
    direction={direction}
  />
);

RepliconSlide.propTypes = {
  in: PropTypes.bool,
  children: PropTypes.oneOf([PropTypes.object, PropTypes.node]).isRequired,
  direction: PropTypes.oneOf([
    SLIDE_DIRECTION.DOWN,
    SLIDE_DIRECTION.LEFT,
    SLIDE_DIRECTION.RIGHT,
    SLIDE_DIRECTION.UP
  ])
};

export default RepliconSlide;
